module.exports = __webpack_public_path__ + "img/LifeChain_Logo_Inverted.a87cbd90.png";